exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open-mini-wrapper[data-v-2bc8da85]{width:100vw;height:100vh;position:relative}.open-btn[data-v-2bc8da85]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports
